<template>
  <div id="Landing">
    <div class="video-wrapper desktop-video">
      <vueVimeoPlayer 
        @ready="onReady"
        ref="player"
        video-id="486899867"
        controls="false"
        :options="options"
      >
      </vueVimeoPlayer>
    </div>
    <div class="video-wrapper mobile-video">
      <!-- <div class="overlay"></div> -->
      <vueVimeoPlayer 
        @ready="onReady"
        ref="player"
        video-id="486897818"
        controls="false"
        :options="options"
        class="heroVideo"
      >
        
      </vueVimeoPlayer>
    </div>
    <b-container>
      <b-row class="flex-sm-row-reverse layoutRow">
        <b-col lg="6" md="12" class="titles">
          <img class="title" src="@/assets/images/giving-title.png" />
          <p>Presented by <img class="toyota" src="@/assets/icons/toyota-logo.png" /></p>
          <h2>The Gift of Giving Sweepstakes presented by Toyota has ended.</h2>
        </b-col>
        <b-col lg="6" md="12">
         
        </b-col>
      </b-row>
    </b-container>
    <!-- <div class="downArrow" v-scroll-to="'#scrollAnchor'">
      <svg width="28px" height="32px" viewBox="0 0 28 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Welcome" stroke="none" stroke-width="1" fill-rule="evenodd">
          <g id="1---Homepage-Mobile" transform="translate(-174.000000, -618.000000)" fill="#F9A448" class="downArrowSvg">
            <g id="Down-Arrow" transform="translate(173.000000, 618.000000)">
              <path d="M4.97271417,15.6095739 L14.999,25.454 L25.0272858,15.6095739 C25.9375159,14.7158935 27.3958174,14.7158935 28.3060475,15.6095739 L28.3333333,15.6363636 C29.237072,16.5236707 29.2503925,17.9756002 28.3630854,18.8793388 L28.3333333,18.9090909 L28.3333333,18.9090909 L16.6393808,30.3904261 C16.2492822,30.773432 15.7585174,30.9922925 15.2533718,31.0470076 L15.0845756,31.0591666 L15.0845756,31.0591666 L14.9154244,31.0591666 C14.3517842,31.0389017 13.7940621,30.8159882 13.3606192,30.3904261 L1.66666667,18.9090909 C0.762927985,18.0217838 0.749607531,16.5698544 1.6369146,15.6661157 L1.6939525,15.6095739 C2.60418258,14.7158935 4.06248409,14.7158935 4.97271417,15.6095739 Z" id="Combined-Shape"></path>
              <path d="M28.3333333,1.63636364 C29.237072,2.52367071 29.2503925,3.97560016 28.3630854,4.87933884 L28.3333333,4.90909091 L28.3333333,4.90909091 L16.6666667,16.3636364 C16.2460394,16.7766158 15.7102896,17.0018774 15.164074,17.039421 L15,17.0450525 C14.3980116,17.0450525 13.7960233,16.8179138 13.3333333,16.3636364 L1.66666667,4.90909091 C0.762927985,4.02178384 0.749607531,2.56985438 1.6369146,1.6661157 L1.66666667,1.63636364 L1.66666667,1.63636364 C2.5920466,0.727808793 4.07462007,0.727808793 5,1.63636364 L14.9990514,11.4539475 L25,1.63636364 C25.9253799,0.727808793 27.4079534,0.727808793 28.3333333,1.63636364 Z" id="Combined-Shape"></path>
            </g>
          </g>
        </g>
      </svg>
    </div> -->
  </div>
</template>

<script>
import { vueVimeoPlayer } from 'vue-vimeo-player'
export default {
  name: "Landing",
  components: {
    vueVimeoPlayer
  },
  data() {
    return {
      options: {
        muted: true,
        responsive: true,
        autoplay: true,
        autopause: false,
        loop: true
      }
    }
  },
  methods: {
		onReady() {
			this.playerReady = true
    }
    // scrollPage() {
    //   var element = document.getElementById("scrollAnchor")
    //   element.scrollIntoView({
    //     block: 'start',
    //     behavior: 'smooth' 
    //   });
    // }
  }
}
</script>

<style lang="scss" scoped>
  #Landing {
    background-color: $dark-blue;
    position: relative;
    height: 66vw;
    max-height: 100vh;
    overflow: hidden;
    @media (max-width: $lg) {
      background-color: #012b45;
      padding-top: 115px;
      height: 100vh;
    }
    .container {
      height: 100%;
    }
    .layoutRow {
      height: 100%;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      .video-wrapper {
        z-index: 1;
        @media (max-width: $lg) {
          margin-top: 50px;
        }
        .overlay {
          transform: scale(1.5);
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          box-shadow: inset 0 0 60px 60px $dark-blue;
          z-index: 2;
          animation: 2s ease 0s normal forwards 1 fadein;
          @media (max-width: $lg) {
            margin-top: 60px;
          }
          @keyframes fadein{
              0% { opacity:0; }
              66% { opacity:0; }
              100% { opacity:1; }
          }
        }
      }
      .titles {
        z-index: 1002;
        position: relative;
        @media (max-width: $md) {
          bottom: 100px;
        }
        @media (max-width: $sm) {
          bottom: 115px;
        }
        @media (max-width: 320px) {
          bottom: 100px;
        }
        img.title {
          position: absolute;
          right: 15px;
          width: 100%;
          @media (max-width: $lg) {
            width: 80%;
            right: 15px;
          }
          @media (max-width: 320px) {
            top: 20px;
          }
        }
      }
    }
    .heroVideo {
      transform: scale(1.5);
      position: relative;
      
    }
    h2 {
      font-family: 'mr-eaves-modern';
      font-weight: 200;
      font-style: normal;
      font-size: 28px;
      color: #fff;
      text-align: right;
      line-height: 31px;
      margin-top: 15px;
      padding: 20px 0;
      @media (max-width: $lg) {
        font-size: 22px;
        line-height: 24px;
        padding-left: 10%;
      }
      @media only screen and (device-width: 768px) {
        position: relative;
        top: 25px;
      }
      @media (max-width: 325px) {
        font-size: 20px;
      }
    }
    p {
      font-family: 'mr-eaves-modern';
      font-weight: 700;
      font-style: normal;
      font-size: 20px;
      color: #fff;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-top: 175px;
      @media (max-width: $md) {
        margin-top: 140px;
      }
      @media (max-width: $sm) {
        margin-top: 125px;
      }
      .toyota {
        width: 207px;
        position: relative;
        top: 5px;
        margin-left: 20px;
        @media (max-width: $lg) {
          width: 106px;
        }
      }
    }
    .downArrow {
      position: absolute;
      bottom: 15px;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      &:hover {
        .downArrowSvg {
          transition: all 0.25s ease-in-out;
          fill: #fff;
        }
      }
    }
    .mobile-video {
      display: none;
      @media (max-width: $lg) {
        display: block;
        position: absolute;
        top: -700px;
        height: 50%;
        width: 100%;
        .heroVideo {
          transform: scale(1);
        }
      }
      @media (max-width: $md) {
        top: -400px;
      }
      @media (max-width: $sm) {
        @media (max-height: 800px) {
          top: -100px;
        }
        top: 0;
      }
      @media only screen and (device-width: 540px) {
        top: -350px;
      }
      @media only screen and (device-width: 280px) {
        top: 0;
      }
    }
    .desktop-video {
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      height: 100vh;
      width: 100%;
      @media (min-width: 1700px) {
        top: -17%;
      }
      @media (min-width: 2000px) {
        top: -27%;
      }
      @media (min-width: 2200px) {
        top: -40%;
      }
      @media (min-width: 2500px) {
        top: -50%;
      }
      @media (max-width: $lg) {
        display: none;
      }
    }
  }
</style>